<template>
  
    <v-card
        v-if="Object.keys(addedLayers).length===0 && filterInitiated"
        class="text-start added-datasets-ui"
        density="compact"
        :title="$t('added-datasets.title')"
        variant="text"
        
    >
        <template #subtitle>
            <div style="white-space: normal; overflow: visible; text-overflow: unset;" v-show="isMinimized==false">
                {{ $t('added-datasets.subtitle') }}
            </div>
        </template>
        
    </v-card>
    
    
<v-list
   v-show="Object.keys(addedLayers).length > 0 || Object.keys(addedExternallayers || {}).length > 0"
    lines="two"
    style="background-color: transparent;"
    class="ml-1 mr-1 text-left"
>

    <!-- Header -->
    <span
        v-show="!isMinimized"
        style="font-size: 1rem; font-weight: 500;"
        class="ml-2"
    >
        {{$t('added-datasets.dataset-count')}}
        ({{ Object.keys(addedLayers).length }})
    </span>

    <v-divider
        style="margin-left: 15px; margin-right: 15px;"
        class="mt-1 mb-1"
    ></v-divider>


    <!-- draggable list (re-ordering added layers) -->
    <draggable
        v-model="orderedLayers"
        item-key="_layerKey"
        handle=".drag-handle"
        animation="200"
        ghost-class="drag-ghost"
        id="added-indicator-tour"
    >
        <template #item="{ element: addedLayer, index }">

            <v-list-item
                :key="addedLayer._layerKey"
                style="border-radius: 5px;"
                @click="addDataUI(
                    addedLayer.dct_title,
                    addedLayer.dct_type,
                    addedLayer.geometry_type,
                    addedLayer.dcatde_politicalgeocodingleveluri
                )"
                @mouseover="hoveredItem = index"
                @mouseleave="hoveredItem = null"
            >

                <template #prepend>

                    <v-icon
                        class="drag-handle mr-2"
                        size="20"
                    >
                        mdi-drag-vertical
                    </v-icon>

                    <v-avatar>
                        <v-img
                            :src="getIcon(
                                addedLayer.checked,
                                addedLayer.geometry_type
                            )"
                            max-height="40"
                            max-width="40"
                        />
                    </v-avatar>

                </template>


                <v-list-item-subtitle
                    v-if="addedLayer.dct_type === 'indikator'"
                    class="text-wrap text-caption"
                >
                    {{ addedLayer.dcatde_politicalgeocodingleveluri }},
                    {{
                        formatAvailableYears(
                            indicatorStore?.indicatorArray?.[
                                addedLayer.dct_title +
                                '_' +
                                addedLayer.dcatde_politicalgeocodingleveluri
                            ]?.availailableYearsForSelectedIndicator
                        )
                    }}
                </v-list-item-subtitle>


                <v-list-item-title
                    v-show="!isMinimized"
                    class="text-wrap"
                >
                    {{ addedLayer.dct_title }}

                    <span>
                        ({{
                            indicatorStore?.indicatorArray?.[
                                addedLayer.dct_title +
                                '_' +
                                addedLayer.dcatde_politicalgeocodingleveluri
                            ]?.selectedYear
                        }})
                    </span>
                </v-list-item-title>


                <v-list-item-subtitle
                    v-show="!isMinimized"
                    class="text-wrap text-caption"
                >
                    {{ addedLayer.dct_catalog_publisher }}
                </v-list-item-subtitle>


                <template #append>

                    <v-menu
                        activator="parent"
                        offset-y
                        close-on-click
                        close-on-content-click
                    >

                        <template #activator="{ props }">

                            <v-btn
                                v-show="!isMinimized"
                                v-bind="props"
                                density="compact"
                                variant="text"
                                icon
                                id="added-layer-ellipsis-btn"
                            >
                                <img
                                    src="icons/ellipsis-vertical.svg"
                                    alt="More Options Icon"
                                    width="30"
                                    height="30"
                                />
                            </v-btn>

                        </template>


                        <v-list
                            style="
                                border-radius: 8px;
                                border: 1px solid rgba(0, 0, 0, 0.2);
                            "
                             id="added-layer-ellipsis-list"
                            
                        >

                            <!-- SHOW / HIDE -->
                            <v-list-item
                                v-if="
                                    addedLayers[
                                        addedLayer.dct_title +
                                        '_' +
                                        addedLayer.dcatde_politicalgeocodingleveluri
                                    ]?.dct_type === 'table'
                                "
                                @click.stop="toggleLayerVisibility(addedLayer)"
                            >
                                <template #prepend>
                                    <v-btn
                                        density="compact"
                                        variant="text"
                                        icon
                                    >
                                        <img
                                            :src="
                                                addedLayers[
                                                    addedLayer.dct_title +
                                                    '_' +
                                                    addedLayer.dcatde_politicalgeocodingleveluri
                                                ]?.checked
                                                    ? 'icons/eye-close.svg'
                                                    : 'icons/eye-open.svg'
                                            "
                                            alt="Visibility Icon"
                                            width="18"
                                            height="18"
                                        />
                                    </v-btn>

                                    <v-list-item-title class="ml-3">
                                        {{
                                            addedLayers[
                                                addedLayer.dct_title +
                                                '_' +
                                                addedLayer.dcatde_politicalgeocodingleveluri
                                            ]?.checked
                                                ? $t('added-datasets.hide')
                                                : $t('added-datasets.show')
                                        }}
                                    </v-list-item-title>
                                </template>
                            </v-list-item>


                            <!-- METADATA -->
                            <v-list-item
                                @click.stop="showLayerMetadata(addedLayer)"
                            >
                                <template #prepend>
                                    <v-btn
                                        density="compact"
                                        variant="text"
                                        icon
                                    >
                                        <IconInformation :size="18" />
                                    </v-btn>

                                    <v-list-item-title class="ml-3">
                                        {{ $t('added-datasets.metadata') }}
                                    </v-list-item-title>
                                </template>
                            </v-list-item>


                            <!-- ZOOM -->
                            <v-list-item
                                v-if="
                                    addedLayers[
                                        addedLayer.dct_title +
                                        '_' +
                                        addedLayer.dcatde_politicalgeocodingleveluri
                                    ]?.dct_type === 'table'
                                    ||
                                    (
                                        addedLayer.dct_type === 'raster'
                                        &&
                                        addedLayer.bbox
                                    )
                                    ||
                                    addedLayer.dct_type === 'indikator'
                                "
                                @click.stop="getLayerExtentFromDB(addedLayer)"
                            >
                                <template #prepend>
                                    <v-btn
                                        density="compact"
                                        variant="text"
                                        icon
                                    >
                                        <img
                                            src="icons/search.svg"
                                            alt="Zoom Icon"
                                            width="18"
                                            height="18"
                                        />
                                    </v-btn>

                                    <v-list-item-title class="ml-3">
                                        {{ $t('added-datasets.zoom') }}
                                    </v-list-item-title>
                                </template>
                            </v-list-item>


                            <!-- REMOVE -->
                            <v-list-item
                                v-show="route?.query?.mode === 'edit'"
                                @click.stop="
                                    addedLayer.dct_type === 'raster'
                                    ||
                                    addedLayer.dct_type === DatasetTypes.SensorThings
                                        ? removeLayer(
                                            addedLayer.dct_title,
                                            addedLayer.dct_type
                                        )
                                        : removeLayer(
                                            addedLayer.dct_title +
                                            '_' +
                                            addedLayer.dcatde_politicalgeocodingleveluri,
                                            addedLayer.dct_type
                                        )
                                "
                            >
                                <template #prepend>
                                    <v-btn
                                        density="compact"
                                        variant="text"
                                        icon
                                    >
                                        <img
                                            src="icons/delete.svg"
                                            alt="Remove Icon"
                                            width="18"
                                            height="18"
                                        />
                                    </v-btn>

                                    <v-list-item-title class="ml-3">
                                        {{ $t('added-datasets.remove') }}
                                    </v-list-item-title>
                                </template>
                            </v-list-item>


                            <!-- EXPORT -->
                            <v-menu
                                open-on-click
                                location="end"
                                offset-x
                                
                            >
                                <template #activator="{ props }">

                                    <v-list-item
                                        v-if="
                                            addedLayer.dct_type === 'indikator'
                                            ||
                                            addedLayer.dct_type === 'custom indikator'
                                        "
                                        v-bind="props"
                                        class="v-list-item-export"
                                        
                                    >

                                        <template #prepend>
                                            <v-btn
                                                density="compact"
                                                variant="text"
                                                icon
                                                aria-label="Export Menu"
                                                id="added-layer-ellipsis-export-data-btn"
                                            >
                                                <img
                                                    src="icons/export.svg"
                                                    alt="Export Icon"
                                                    width="18"
                                                    height="18"
                                                />
                                            </v-btn>
                                        </template>

                                        <v-list-item-title class="ml-3">
                                            {{ $t('added-datasets.export') }}
                                        </v-list-item-title>

                                        <template #append>
                                            <v-icon size="small">
                                                mdi-chevron-right
                                            </v-icon>
                                        </template>

                                    </v-list-item>

                                </template>


                                <v-list id="added-layer-ellipsis-export-data-list">

                                    <v-list-item
                                        @click.stop="
                                            exportData(
                                                addedLayer.dct_title,
                                                addedLayer.dct_type,
                                                { mode: 'geojson' },
                                                addedLayer.dcatde_politicalgeocodingleveluri
                                            )
                                        "
                                    >
                                        <v-list-item-title>
                                            GeoJSON
                                        </v-list-item-title>
                                    </v-list-item>


                                    <v-list-item
                                        @click.stop="
                                            exportData(
                                                addedLayer.dct_title,
                                                addedLayer.dct_type,
                                                { mode: 'csv' },
                                                addedLayer.dcatde_politicalgeocodingleveluri
                                            )
                                        "
                                    >
                                        <v-list-item-title>
                                            CSV
                                        </v-list-item-title>
                                    </v-list-item>

                                </v-list>

                            </v-menu>

                        </v-list>

                    </v-menu>

                </template>

            </v-list-item>

        </template>
    </draggable>
    <!-- ========== EXTERNAL / UPLOADED LAYERS ========== -->
<!-- ========== EXTERNAL / UPLOADED LAYERS ========== -->
<template v-if="Object.keys(addedExternallayers || {}).length > 0">
  <span
    v-show="!isMinimized"
    style="font-size: 1rem; font-weight: 500;"
    class="ml-2 mt-3 d-block"
  >
    Uploaded layers
    ({{ Object.keys(addedExternallayers).length }})
  </span>

  <v-divider
    style="margin-left: 15px; margin-right: 15px;"
    class="mt-1 mb-1"
  />

  <draggable
    v-model="orderedExternalLayers"
    item-key="_layerKey"
    handle=".drag-handle"
    animation="200"
    ghost-class="drag-ghost"
  >
    <template #item="{ element: externalLayer, index }">
      <v-list-item
        :key="externalLayer._layerKey"
        style="border-radius: 5px;"
        @mouseover="hoveredExternalItem = index"
        @mouseleave="hoveredExternalItem = null"
        @click="addDataUI(
                    externalLayer.dct_title,
                    externalLayer.dct_type,
                    externalLayer.geometry_type,
                    externalLayer.dcatde_politicalgeocodingleveluri
                )"
      >
        <template #prepend>
          <v-icon class="drag-handle mr-2" size="20">
            mdi-drag-vertical
          </v-icon>

          <v-avatar>
            <v-img
              :src="getIcon(externalLayer.checked, externalLayer.geometry_type)"
              max-height="40"
              max-width="40"
            />
          </v-avatar>
        </template>

        <v-list-item-title v-show="!isMinimized" class="text-wrap">
          {{ externalLayer.dct_title || externalLayer.name }}
        </v-list-item-title>

        <v-list-item-subtitle
          v-show="!isMinimized"
          class="text-wrap text-caption"
        >
          {{ externalLayer.geometry_type }}
          <span v-if="externalLayer.source"> · {{ externalLayer.source }}</span>
        </v-list-item-subtitle>

        <template #append>
          <v-menu
              activator="parent"
              offset-y
              close-on-click
              close-on-content-click
            >
              <template #activator="{ props }">
                <v-btn
                  v-show="!isMinimized"
                  v-bind="props"
                  density="compact"
                  variant="text"
                  icon
                >
                  <img
                    src="icons/ellipsis-vertical.svg"
                    alt="More Options"
                    width="30"
                    height="30"
                  />
                </v-btn>
              </template>

              <v-list
                style="border-radius: 8px; border: 1px solid rgba(0, 0, 0, 0.2);"
              >
                <!-- SHOW / HIDE -->
                <v-list-item @click.stop="toggleLayerVisibility(externalLayer)">
                  <template #prepend>
                    <v-btn density="compact" variant="text" icon>
                      <img
                        :src="externalLayer.checked ? 'icons/eye-close.svg' : 'icons/eye-open.svg'"
                        alt="Visibility"
                        width="18"
                        height="18"
                      />
                    </v-btn>
                    <v-list-item-title class="ml-3">
                      {{ externalLayer.checked
                        ? $t('added-datasets.hide')
                        : $t('added-datasets.show') }}
                    </v-list-item-title>
                  </template>
                </v-list-item>

                <!-- ZOOM (uses bbox from turf) -->
                <v-list-item
                  v-if="externalLayer.dct_bbox || externalLayer.bbox"
                  @click.stop="getLayerExtentFromDB(externalLayer)"
                >
                  <template #prepend>
                    <v-btn density="compact" variant="text" icon>
                      <img src="icons/search.svg" alt="Zoom" width="18" height="18" />
                    </v-btn>
                    <v-list-item-title class="ml-3">
                      {{ $t('added-datasets.zoom') }}
                    </v-list-item-title>
                  </template>
                </v-list-item>

                <!-- REMOVE -->
                <v-list-item
                  v-show="route?.query?.mode === 'edit'"
                  @click.stop="removeLayer(
                                            externalLayer.dct_title,
                                            externalLayer.dct_type
                                )"
                >
                  <template #prepend>
                    <v-btn density="compact" variant="text" icon>
                      <img src="icons/delete.svg" alt="Remove" width="18" height="18" />
                    </v-btn>
                    <v-list-item-title class="ml-3">
                      {{ $t('added-datasets.remove') }}
                    </v-list-item-title>
                  </template>
                </v-list-item>
              </v-list>
            </v-menu>
        </template>
      </v-list-item>
    </template>
  </draggable>
</template>

</v-list>

</template>

<script setup>
import {ref, defineEmits, computed, onMounted, onUnmounted} from 'vue'
import { storeToRefs } from 'pinia'
import { useaddedDatasetsStore } from '../stores/addedDatasets'
import { useDatasetSearchStore } from '../stores/datasetSearch'
import { useMetadataDialogStore } from '../stores/metadataDialog'
import { useMapLegendStore } from '@/stores/mapLegend'
import { useIndicatorStore } from '@/stores/indicator'
import { createHistogram } from '../utils/histogram';
import { DatasetTypes } from '../utils/datasetTypes';


import { useCartographyStore } from '../stores/cartography'
import { usePointStyleStore } from '../stores/pointStyle'
import { usePolygonStyleStore } from '../stores/polygonStyle'
import { useLineStyleStore } from '../stores/lineStyle'
import { useRasterStyleStore } from '../stores/rasterStyle'
import { useAlertStore } from '@/stores/alert'
import { useMenuStore } from '../stores/menu'
import { useProgressStore } from '@/stores/progress'
import { useRoute } from "vue-router"
import IconInformation from '@/components/icons/IconInformation.vue'
import draggable from 'vuedraggable'
const route = useRoute()

const progressStore = useProgressStore()
const alertStore = useAlertStore()

let { isMinimized } = storeToRefs(useMenuStore())
const cartographyStore = useCartographyStore()
const pointStyleStore = usePointStyleStore()
const polygonStyleStore = usePolygonStyleStore()
const lineStyleStore = useLineStyleStore()
const rasterStyleStore = useRasterStyleStore()
let { layerSpecification } = storeToRefs(usePointStyleStore())
let { polygonLayerSpecification } = storeToRefs(usePolygonStyleStore())
let { lineLayerSpecification } = storeToRefs(useLineStyleStore())
let { rasterLayerSpecification } = storeToRefs(useRasterStyleStore())


import {
    getLayerExtent,
    getGeojsonDataFromDB
} from "../services/backend.calls";

const emit = defineEmits(["addLayerToMap", "toggleLayerVisibility",  "addCoverageLayerToMap", "toggleCoverageLayerVisibility", "fitBoundsToBBOX", "removeLayerFromMap", "toggleLayerVisibilityWithValue", "moveLayerToTop", "removeSensorThingsLayerFromMap", "layers-reordered"]);

const metadataDialogStore = useMetadataDialogStore();
const mapLegendStore = useMapLegendStore();

const indicatorStore = useIndicatorStore()

const datasetSearchStore = useDatasetSearchStore()

const addedDatasetsStore = useaddedDatasetsStore()

let { addedLayers, addedExternallayers} = storeToRefs(useaddedDatasetsStore())
let { filterInitiated} = storeToRefs(useDatasetSearchStore())

const hoveredExternalItem = ref(null)

const orderedExternalLayers = computed({
  get() {
        return Object.keys(addedExternallayers.value)
            .reverse()
            .map(key => ({
                ...addedExternallayers.value[key],
                _layerKey: key
            }))
    },

    set(newOrder) {
        const reordered = {}

        newOrder.forEach(layer => {
            reordered[layer._layerKey] =
                addedExternallayers.value[layer._layerKey]
        })

        addedExternallayers.value = Object.fromEntries(
            Object.entries(reordered).reverse()
        )
        console.log(newOrder, "newOrder")
        emit('layers-reordered', newOrder)
        
       addDataUI(
            newOrder[0].dct_title,
            newOrder[0].dct_type,
            newOrder[0].geometry_type,
            newOrder[0].dcatde_politicalgeocodingleveluri
        )
        datasetSearchStore.toggleDataUI({
                dataUiInitiated : false
        })
       
       
    }
})
let hoveredItem = ref(null)

function handleTourAddDataUI(event) {
  const { title, layerType, geometryType, geocodingLevel } = event.detail
  addDataUI(title, layerType, geometryType, geocodingLevel)
}
function handleTourRemoveLayer(event) {
    const { layerName, layerType } = event.detail
  removeLayer(layerName, layerType)
}
onMounted(() => {
    window.addEventListener('tour:add-data-ui', handleTourAddDataUI)
    window.addEventListener('tour:remove-layer', handleTourRemoveLayer)

})
onUnmounted(() => {
    window.removeEventListener('tour:add-data-ui', handleTourAddDataUI)
    window.removeEventListener('tour:remove-layer', handleTourRemoveLayer)

})
const orderedLayers = computed({
    get() {
        return Object.keys(addedLayers.value)
            .reverse()
            .map(key => ({
                ...addedLayers.value[key],
                _layerKey: key
            }))
    },

    set(newOrder) {
        const reordered = {}

        newOrder.forEach(layer => {
            reordered[layer._layerKey] =
                addedLayers.value[layer._layerKey]
        })

        addedLayers.value = Object.fromEntries(
            Object.entries(reordered).reverse()
        )

        emit('layers-reordered', newOrder)
        
       addDataUI(
            newOrder[0].dct_title,
            newOrder[0].dct_type,
            newOrder[0].geometry_type,
            newOrder[0].dcatde_politicalgeocodingleveluri
        )
        datasetSearchStore.toggleDataUI({
                dataUiInitiated : false
        })
       
       
    }
})
const formatAvailableYears = (years) => {
  if (!Array.isArray(years) || years.length === 0) return ''

  if (years.length === 1) return years[0]

  if (years.length === 2) return `${years[0]}, ${years[1]}`

  return `${years[0]}–${years[years.length - 1]}`
}
const addDataUI = (datasettitle, datasetType, geomType, granularity)=> {
    let datasetName = datasettitle+'_'+granularity
    if (datasetSearchStore.selectedDataset==datasetName && filterInitiated==false){
        removeLayer(datasetName, datasetType)
    }
    else {
        if (datasetType != DatasetTypes.SensorThings) {
            datasetSearchStore.toggleDataUI({
                dataUiInitiated : true
            })
            datasetSearchStore.toggleFilter({
                filterInitiated : false
            })
            datasetSearchStore.setSelecteddatasetName({
                selectedDataset: datasetType=='indikator'? datasetName: datasettitle
            })
        }
        if(datasetType==DatasetTypes.Indicator){
            createHistogramForSelectedLayer(datasetName)
            for(let layer in addedDatasetsStore.addedLayers){
                if (layer!=datasetName){
                    emit("toggleLayerVisibilityWithValue", 'kommunales_gebiet_dashboard' + layer, 'none')
                    if(addedDatasetsStore.addedLayers[layer]['dct_type']== DatasetTypes.Indicator || addedDatasetsStore.addedLayers[layer]['dct_type']== DatasetTypes.CustomIndicator ){
                        addedDatasetsStore.addedLayers[layer]['checked'] = false;
                    }
                }
                else {
                    emit("toggleLayerVisibilityWithValue", 'kommunales_gebiet_dashboard' + layer, 'visible')
                    if(addedDatasetsStore.addedLayers[layer]['dct_type']== DatasetTypes.Indicator){
                        addedDatasetsStore.addedLayers[layer]['checked'] = true;
                    }
                    
                }
                
            }
            datasetSearchStore.setSelecteddatasetType({
                selectedDatasetType: "indikator"
            })
            emit("moveLayerToTop", 'kommunales_gebiet_dashboard' + datasetName)

        }
        else if (datasetType==DatasetTypes.Table || datasetType==DatasetTypes.UploadedGeojson){
           
            
            datasetSearchStore.setSelecteddatasetName({
                selectedDataset: datasettitle
            })
            activateStylePanel(datasettitle,geomType)
            
            
        }
        else if(datasetType=='raster'){
            activateStylePanel(datasettitle,geomType)
            datasetSearchStore.setSelecteddatasetType({
                selectedDatasetType: "raster"
            })
            emit("moveLayerToTop", datasettitle)
            
        }
        else if(datasetType=='custom indikator'){
            datasetName = datasettitle
            for(let layer in addedDatasetsStore.addedLayers){
                if (layer!=datasetName){
                    emit("toggleLayerVisibilityWithValue", 'kommunales_gebiet_dashboard' + layer, 'none')
                    if(addedDatasetsStore.addedLayers[layer]['dct_type']== DatasetTypes.CustomIndicator || addedDatasetsStore.addedLayers[layer]['dct_type']== DatasetTypes.Indicator){
                        addedDatasetsStore.addedLayers[layer]['checked'] = false;
                    }
                }
                else {
                    emit("toggleLayerVisibilityWithValue", 'kommunales_gebiet_dashboard' + layer, 'visible')
                    if(addedDatasetsStore.addedLayers[layer]['dct_type']== DatasetTypes.CustomIndicator){
                        addedDatasetsStore.addedLayers[layer]['checked'] = true;
                    }
                    
                }
                
            }
        }
    }
    
    
}

const createHistogramForSelectedLayer = (datasetName)=>{
    let wertValues = indicatorStore.indicatorArray[datasetName][0][0]
    .filter(item => item.zeitbezug === indicatorStore.indicatorArray[datasetName].selectedYear)
    .map(item => item.wert);
    createHistogram(wertValues, "histogram");
}

const showLayerMetadata = (addedLayer)=>{ 
    metadataDialogStore.assignMetadata( addedLayer,addedLayer.dct_title)
}
const getLayerExtentFromDB = async (addedLayer)=>{

    if (addedLayer.dct_type=='table'){
        const layerExtent =  await getLayerExtent(addedLayer.dct_title)
        emit("fitBoundsToBBOX", [layerExtent['x-min'], layerExtent['y-min'], layerExtent['x-max'], layerExtent['y-max']])
    }
    else if (addedLayer.dct_type=='raster'){ 
        console.log(addedLayer, "addedLayer")
        /* the bbox from WMS coming from metadate table in GeoJson format
        so it needs to be transfromed to Maplibre fitBounds format
        */
        try {
            
       
       if ( addedLayer.bbox && addedLayer.bbox.length > 0) {
         // for external WMS layersstored in DB
            const bbox = addedLayer.bbox[0];
            emit("fitBoundsToBBOX", [bbox.miny, bbox.minx, bbox.maxy, bbox.maxx]);
        } else {
            // for external WMS layers uploaded by user
           emit("fitBoundsToBBOX", addedLayer.dct_bbox)
        }
       

        } catch (e) {
            console.error("Failed to parse bbox:", e);
        }
            
    }
    else if(addedLayer.dct_type=='indikator'){
        const layerExtent =  await getLayerExtent(addedLayer.dcatde_politicalgeocodingleveluri)
        emit("fitBoundsToBBOX", [layerExtent['x-min'], layerExtent['y-min'], layerExtent['x-max'], layerExtent['y-max']])
       
    }
    else if (addedLayer.dct_type=='geojson'){
        emit("fitBoundsToBBOX", addedLayer.dct_bbox)
    }
    
}

const toggleLayerVisibility = (layerName)=>{
    
    if (layerName.dct_type==DatasetTypes.Table){
        emit("toggleLayerVisibility", layerName.dct_title)
        if(addedLayers.value[layerName.dct_title]['sublayers']){
            for(let sublayer in (addedLayers.value[layerName.dct_title]['sublayers'])){
                emit("toggleLayerVisibility", sublayer)
            }
        }
    }
    else if (layerName.dct_type==DatasetTypes.Indicator){
        emit("toggleLayerVisibility", 'kommunales_gebiet_dashboard' + layerName.dct_title)
         addedLayers.value[layerName.dct_title]['checked'] =! addedLayers.value[layerName.dct_title]['checked']
    }
    else if (layerName.dct_type=='geojson'){
        emit("toggleLayerVisibility", layerName.dct_title)
        addedExternallayers.value[layerName.dct_title]['checked'] =! addedExternallayers.value[layerName.dct_title]['checked']
    }
    else if (layerName.dct_type=='raster'){
        emit("toggleLayerVisibility", layerName.dct_title)
        addedExternallayers.value[layerName.dct_title]['checked'] =! addedExternallayers.value[layerName.dct_title]['checked']
    }
    

    
  
    
}

const removeLayer = (layerName, layerType)=>{
    if (layerName===datasetSearchStore.selectedDataset){
        datasetSearchStore.toggleDataUI({
            dataUiInitiated : false
        })
    }
    
    if (layerType==DatasetTypes.Table){
        emit("removeLayerFromMap",  {layerId:  layerName, sourceId: layerName})
        if(addedDatasetsStore.addedLayers[layerName]['sublayers']){
            for (let sublayerId in addedDatasetsStore.addedLayers[layerName]['sublayers']){
                emit("removeLayerFromMap",  {layerId:  sublayerId, sourceId: sublayerId})
            }
       
        }
    }
    else if (layerType==DatasetTypes.Indicator){
        emit("removeLayerFromMap",  {layerId:  'kommunales_gebiet_dashboard' + layerName, sourceId: 'kommunales_gebiet_dashboard' + layerName})
        emit("removeLayerFromMap",  {layerId: "highlight", sourceId: "highlight"})
        console.log(addedDatasetsStore.addedLayers[layerName], "added layers before emoval")

        mapLegendStore.removeLegendItem(layerName);
        indicatorStore.removeIndicator(layerName)
        
    }
    else if(layerType=='raster'){
        
        emit("removeLayerFromMap",  {layerId:  layerName, sourceId: layerName})

        // for external uploaded WMS layers 
        if (addedDatasetsStore.addedLayers[layerName]==undefined){
            mapLegendStore.removeWMSLegendItem({
                        legend_url: addedDatasetsStore.addedExternallayers[layerName].legend_url,
                        layername: layerName
            })
            addedDatasetsStore.removeExternallayer(layerName)
        }
        // for external WMS layers stored in DB
        else {
            mapLegendStore.removeWMSLegendItem({
                        legend_url: addedDatasetsStore.addedLayers[layerName].legend_url,
                        layername: layerName
            })
        }
        
    }
    else if (layerType==DatasetTypes.CustomIndicator){
        emit("removeLayerFromMap",  {layerId:  'kommunales_gebiet_dashboard' + layerName, sourceId: 'kommunales_gebiet_dashboard' + layerName})
        emit("removeLayerFromMap",  {layerId: "highlight", sourceId: "highlight"})
        mapLegendStore.removeLegendItem(layerName);
        indicatorStore.removeIndicator(layerName)
    } 
    else if (layerType == DatasetTypes.SensorThings) {
        emit("removeSensorThingsLayerFromMap", layerName);
    }
    else if(layerType=='geojson'){
         emit("removeLayerFromMap",  {layerId:  layerName, sourceId: layerName})
        addedDatasetsStore.removeExternallayer(layerName)
    }
   
    delete addedLayers.value[layerName];
    addedDatasetsStore.removeLayer(layerName)
    console.log(addedDatasetsStore.addedLayers[layerName], "added layers after emoval")
}
const activateStylePanel = (datasetName,geomType)=>{
   cartographyStore.setVisibility({catographyUIVisibility:true, geomTtype: geomType})
   let layerSpec= {
        "name": datasetName,
        "type": geomType,
        "metadata": null,
        "checked": true,
        "sublayers": []
    }
   if(geomType==='Point'){
       layerSpecification.value=layerSpec
       pointStyleStore.addLayerStyle(datasetName)
   }
   else if (geomType == "MultiPolygon" || geomType == "Polygon" || geomType == "Geometry"){
       polygonLayerSpecification.value=layerSpec
       polygonStyleStore.addLayerStyle(datasetName)
   }
   else if(geomType == "MultiLineString" || geomType == "LineString" || geomType == "Line"){
       lineLayerSpecification.value=layerSpec
       lineStyleStore.addLayerStyle(datasetName)
   }
   else if (geomType == "raster"){
    console.log(layerSpec, datasetName, geomType, "layerSpec")

        rasterLayerSpecification.value=layerSpec
        rasterStyleStore.addLayerStyle(datasetName)
        // for external user uploaded WMS layer
        if (addedDatasetsStore.addedLayers[datasetName]==undefined){
            mapLegendStore.setActivatedWMSLegendItem({
                legend_url: addedDatasetsStore.addedExternallayers[datasetName].legend_url,
                legend_title: datasetName
            })
            if (addedDatasetsStore.addedExternallayers[datasetName].legend_url== undefined){
                alertStore.setAlert({
                        text: `There is no legend for ${addedDatasetsStore.addedExternallayers[datasetName].dct_title}`,
                        timeout: 2000
                    });
            }
        }
        // for external WMS layer stored in DB
        else {
            mapLegendStore.setActivatedWMSLegendItem({
                legend_url: addedDatasetsStore.addedLayers[datasetName].legend_url,
                legend_title: datasetName
            })
            if (addedDatasetsStore.addedLayers[datasetName]?.legend_url== undefined){
                alertStore.setAlert({
                        text: `There is no legend for ${addedDatasetsStore.addedLayers[datasetName]?.dct_title}`,
                        timeout: 2000
                    });
            }
        }

   }
   
  
  

}
const getIcon = (checked, geomType)=> {
   
    if (geomType=='Point'){
        if (checked){
            return 'icons/point.svg';
        }
        else {
            return 'icons/point-blue.svg';
        }
    }
    else if (geomType == "MultiLineString" || geomType == "LineString" || geomType == "Line"){
        if (checked){
            return 'icons/line.svg';
        }
        else {
            return 'icons/line-blue.svg';
        }
    }
    else if (geomType == "MultiPolygon" || geomType == "Polygon" || geomType == "Geometry"){
        if(checked){
            return 'icons/polygon.svg';
        }
        else {
            return 'icons/polygon-blue.svg';
        }
    }
    else {
        return 'icons/raster.svg';
    }
  }
const exportData = async(layerName, type, exportType, granularity)=>{
    progressStore.setProgressBar({
        text: `Exporting ${layerName} to ${exportType.mode}...`,
        progress: true
    })
    let indicatorArray = indicatorStore.indicatorArray[layerName+'_'+granularity][0][0]
    let selectedYear = indicatorStore.indicatorArray[layerName+'_'+granularity].selectedYear
    let filteredArray
    if (type =="indikator"){
        filteredArray = indicatorArray.filter(item => item.zeitbezug === selectedYear);
    }
    else if (type =="custom indikator"){
        filteredArray = indicatorArray
    }

    const data =  await getGeojsonDataFromDB(granularity)
    const valueMap = new Map(
    filteredArray.map(item => [String(item.kennziffer), item])
    );

    // 2️⃣ Merge attributes into the GeoJSON
    data.features = data.features.map(feature => {
        const nationalco = String(feature.properties.nationalco);
        const match = valueMap.get(nationalco);

        if (match) {
            feature.properties = {
            ...feature.properties,
            ...match, // adds wert, zeitbezug, etc.
            };
        } else {
            // If no match, you can assign default/null values
            feature.properties = {
            ...feature.properties,
            wert: null
            };
        }

        return feature;
    });
    if (exportType.mode === "geojson"){
        const geojsonStr = JSON.stringify(data, null, 2);
        const blob = new Blob([geojsonStr], { type: "application/geo+json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${layerName}_${selectedYear}.geojson`;
        a.click();
        URL.revokeObjectURL(url);
    }
    else if (exportType.mode === "csv") {
        const csvRows = [];
        const headers = Object.keys(data.features[0].properties);
        csvRows.push(headers.join(",")); // header row

        data.features.forEach(f => {
        const row = headers.map(h => {
            let val = f.properties[h];
            if (val === null || val === undefined) return "";
            if (typeof val === "string" && val.includes(",")) {
            // Escape commas and quotes
            return `"${val.replace(/"/g, '""')}"`;
            }
            return val;
        });
        csvRows.push(row.join(","));
        });

        const csvStr = csvRows.join("\n");
        const blob = new Blob([csvStr], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${layerName}_${selectedYear}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }
    
    progressStore.setProgressBar({
        progress: false
    })
   
}
</script>

<style scoped>

.header{
    overflow-y: scroll;
    border-radius: 8px;
    position: absolute;
    top: 62px;
    left: 381px;
    z-index: 10;
    background-color: var(--color-background, rgba(0,0,0,1));
    color: white;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
.drag-handle {
    cursor: grab;
}

.drag-handle:active {
    cursor: grabbing;
}

.drag-ghost {
    opacity: 0.4;
}
</style>